import React from "react";
import { Helmet } from "react-helmet-async";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import HomeIcon from "@mui/icons-material/Home";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import Link from "@mui/material/Link";
import Container from "../../common/Container";
import AppBar from "@mui/material/AppBar";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import library from "../../assets/images/library.jpg";

const Utme = () => {
  return (
    <Box>
      <Helmet>
        <title>
          Oluseun Onigbinde Resource Centre Provides Free JAMB Forms to Indigent
          Students | Oluseun Onigbinde Resource Centre
        </title>
      </Helmet>
      <AppBar
        position={"sticky"}
        elevation={0}
        padding={"5px 0px"}
        sx={{
          backgroundColor: "#F6F5F5",
        }}
      >
        <Container paddingY={{ xs: 1 / 2, sm: 1 / 2 }}>
          <Header />
        </Container>
      </AppBar>
      <Box bgcolor={"#F6F5F5"}>
        <Container>
          <Box
            sx={{
              position: "relative",
              "&::after": {
                position: "absolute",
                content: '""',
                width: "30%",
                zIndex: 1,
                top: 0,
                right: 0,
                height: "80%",
                backgroundSize: "18px 18px",
                backgroundImage: `radial-gradient(${"#071783"} 20%, transparent 30%)`,
                opacity: 0.1,
              },
            }}
          >
            <Typography
              gutterBottom
              fontWeight={300}
              variant="h3"
              paddingTop={{ xs: "35%", sm: "5%" }}
              color="#071783"
            >
              Oluseun Onigbinde Resource Centre Provides Free JAMB Forms to
              Indigent Students
            </Typography>
            <Box
              width={{ xs: "80%", sm: "15%" }}
              marginLeft={{ xs: "0%", sm: "0%" }}
            >
              <Breadcrumbs
                aria-label="breadcrumb"
                separator={<DoubleArrowIcon fontSize="small" />}
              >
                <Link
                  underline="hover"
                  sx={{ display: "flex", alignItems: "center" }}
                  color="#000"
                  href="/"
                  gap={0.5}
                >
                  <HomeIcon
                    sx={{ color: "#071783", width: 18, height: 18 }}
                    fontSize="inherit"
                  />
                  Home
                </Link>
                <Link
                  underline="hover"
                  sx={{ display: "flex", alignItems: "center" }}
                  color="#000"
                  href="/our-events"
                  gap={0.5}
                >
                  <MenuBookIcon
                    sx={{ color: "#071783", width: 18, height: 18 }}
                    fontSize="inherit"
                  />
                  Events
                </Link>
              </Breadcrumbs>
            </Box>
          </Box>
        </Container>
      </Box>
      <Box bgcolor={"#F6F5F5"}>
        <Container>
          <Grid
            container
            display={"flex"}
            alignItems={"flex-start"}
            margin={{ xs: "0%", sm: "2% 0%" }}
          >
            <Grid
              item
              xs={12}
              sm={6}
              marginBottom={{ xs: "0%", sm: "0%" }}
              padding={{ xs: "15% 0% 15% 0%", sm: "0% 6% 3% 0%" }}
            >
              <Box
                component="img"
                height={{ xs: "45vh", sm: "600px" }}
                width={{ xs: "100%", sm: "100%" }}
                display={{ xs: "block", sm: "none" }}
                marginTop={{ xs: "10%", sm: "0%" }}
                src={library}
                alt={"image"}
                sx={{
                  objectFit: "cover",
                }}
              />

              <Typography
                variant={"body1"}
                fontWeight={700}
                textAlign={"left"}
                color={"#071783"}
                marginTop={{ xs: "5%", sm: "0%" }}
                paddingBottom={"1%"}
              >
                March 2, 2025
              </Typography>
              <Typography
                fontSize={"1.2rem"}
                fontWeight={400}
                textAlign={"left"}
                color={"#000"}
                padding={{ xs: "5% 0% 2% 0%", sm: "0% 0% 0% 0%" }}
                lineHeight={1.5}
              >
                The Oluseun Onigbinde Resource Centre took a significant step in
                supporting access to higher education by providing free JAMB
                forms to indigent secondary school graduates in Oyo State. This
                initiative targeted students who had successfully obtained at
                least five credits in their Senior Secondary School Certificate
                Examination (SSCE) but faced financial barriers in registering
                for the Unified Tertiary Matriculation Examination (UTME). By
                covering the cost of the JAMB forms, the Centre aimed to remove
                one of the obstacles preventing bright but underprivileged
                students from pursuing tertiary education.
              </Typography>

              <Typography
                fontSize={"1.2rem"}
                fontWeight={400}
                textAlign={"left"}
                color={"#000"}
                padding={{ xs: "1% 0%", sm: "4% 0% 0% 0%" }}
                lineHeight={1.5}
              >
                This effort aligns with the Centre’s broader mission of
                promoting education and empowering young minds with
                opportunities for academic and career advancement. Beyond
                financial support, beneficiaries were also encouraged to utilize
                the Centre’s learning resources, including its library and
                digital facilities, to adequately prepare for their exams. By
                investing in these students, the Oluseun Onigbinde Resource
                Centre is not only fostering educational inclusion but also
                contributing to the long-term development of human capital in
                Oyo State.
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              padding={{ xs: "15% 0% 25% 0%", sm: "0% 0% 3% 0%" }}
              margin={{ xs: "25% 0% 10% 0%", sm: "0%" }}
              display={{ xs: "none", sm: "block" }}
            >
              <Box
                component="img"
                height={{ xs: "45vh", sm: "600px" }}
                width={{ xs: "100%", sm: "100%" }}
                src={library}
                alt={"image"}
                sx={{
                  objectFit: "cover",
                }}
              />
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box bgcolor={"#F6F5F5"}>
        <Container>
          <Footer />
        </Container>
      </Box>
    </Box>
  );
};

export default Utme;
